import axios, { RawAxiosRequestHeaders } from 'axios';

import { getAuthHeaders } from '@/lib/httpsAgent';

import { OptionsWithServerSideRequest } from '@/models/api';
import { ProductUnavailableProps } from '@/models/props/ProductsUnavailableProps';

export async function getAllProducts(opts?: OptionsWithServerSideRequest) {
    const headers: RawAxiosRequestHeaders = getAuthHeaders(opts);
    const url = new URL(`${process.env.NEXT_PUBLIC_BASE_URL}/api/products/unavailable`);

    const { data } = await axios.get(url.toString(), { headers }).catch((error) => {
        throw new Error(error || 'Products unavalaible: something went wrong!');
    });

    return data;
}

export async function submitProductId(
    productCode: Pick<ProductUnavailableProps, 'code'>,
    headers?: RawAxiosRequestHeaders
): Promise<Response | string> {
    const url = new URL(
        `${process.env.NEXT_PUBLIC_BASE_URL}/api/products/unavailable/subscribe?productCode=${productCode.code}`
    );

    return axios.post<string, string>(url.toString(), { headers }).catch((error) => {
        throw new Error(error || 'Products unavalaible: something went wrong!');
    });
}

export const UnavailableProductsService = {
    getAllProducts,
    submitProductId
};
